import { render, staticRenderFns } from "./ForgotToScan.vue?vue&type=template&id=52653444&scoped=true&lang=pug&"
import script from "./ForgotToScan.vue?vue&type=script&lang=js&"
export * from "./ForgotToScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52653444",
  null
  
)

export default component.exports